
  export const style={
    inpuStyle:{
      colorInput:"#30064F"
    },
    url:{
      urlClient:"https://uxgroup.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://storage-client-profile.appnoz.com.br/base-api/uploads/logos/profile_client/logoclient/120/logo_preto.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Spin/Spins"
    },
    teamName:{
      name:"uxgroup"
    },
    hasToken: false,
    hostHeader: "uxgroup"
  }
